import _ from 'underscore';

import { CompositeSessionInfoSelectors, SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { getAppStore } from '../../../bootstrap/redux/store/AppStore';
import { Messages } from '../../../codegen/Localize';
import { ExtractEncryptionMode } from '../../../commonInfra/utils/sites/SitePropertyTypes';
import { ExtractEncryptionState, IDataSourceInfo } from '../../../datasource/models/IDataSourceInfo';
import { EntityActionNames, IEntityAction } from '../../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import {
  isAnyDatasoursEncrypted,
isAnyDatasoursUnencrypted,
  isEncryptionEnabled,
  isEncryptionEnforced,
  isWorkbookEncryptedExtract,
  isWorkbookUnencryptedExtract } from '../../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IExtractConvertAction } from '../../../spacesPlatform/models/actionNames';
import { IExplorableItemTypeInfo, ISpaceTypeInfo } from '../../../spacesPlatform/models/resourceInfoParts';
import { selectContentFromAppState } from '../../../spacesPlatform/selectors/ContentSelectors';
import { selectSpaceInfo, selectSpaceInfoItem } from '../../../spacesPlatform/selectors/SpaceInfoSelectors';
import { isWorkbookSpace, SpaceInfo } from '../../../spacesPlatform/state/SpaceInfo';
import { IWorkbookInfo } from '../../../workbook/models/IWorkbookInfo';
import { IWorkbookActions } from '../../../workbook/ServerApi/types/IWorkbookActions';
import { encryptContent, EncryptionActionType } from '../../actions/encryptContent/EncryptContentAction';

export const ExtractsEncryptionEncryptedDsAction: IEntityAction<IWorkbookInfo,  IWorkbookActions> = {
    name: EntityActionNames.ExtractsEncrptionEncrypted,
    translateName: Messages.createExtractsForDsSubActionEncrypted,
    isVisible: (targetItems: IWorkbookInfo[], state: AppState, availableActions: IWorkbookActions) => {
      return isVisibleOnEnabled(state);
    },
    isClickable: (availableActions: IExtractConvertAction, targetItems: IWorkbookInfo[], state: AppState) => {
      return  targetItems[0].extractEncryptionState === ExtractEncryptionState.unencrypted;
    },
    isChecked: (availableActions: IExtractConvertAction, targetItems: IWorkbookInfo[], state: AppState) => {
      return targetItems[0].extractEncryptionState === ExtractEncryptionState.encrypted;
    },
    createReduxAction: (targetItems: IWorkbookInfo[]) => encryptContent(targetItems, EncryptionActionType.encryptExtracts)
};

export const ExtractsEncryptionUnencryptedAction: IEntityAction<IWorkbookInfo, IWorkbookActions> = {
  name: EntityActionNames.ExtractsEncrptionUnencrypted,
  translateName: Messages.createExtractsForDsSubActionUnencrypted,
  isVisible: (targetItems: IWorkbookInfo[], state: AppState, availableActions: IWorkbookActions) => {
    return isVisibleOnEnabled(state);
  },
  isClickable: (availableActions: IWorkbookActions, targetItems: IWorkbookInfo[], state: AppState) => {
    return targetItems[0].extractEncryptionState === ExtractEncryptionState.encrypted;
  },
  isChecked: (availableActions: IWorkbookActions, targetItems: IWorkbookInfo[], state: AppState) => {
    return targetItems[0].extractEncryptionState === ExtractEncryptionState.unencrypted;
  },
  createReduxAction: (targetItems: IWorkbookInfo[]) => encryptContent(targetItems, EncryptionActionType.decryptExtracts)
};

export const ExtractsEncryptionAction: IEntityAction<IWorkbookInfo, IWorkbookActions> = {
  name: EntityActionNames.ExtractsEncrptionAction,
  translateName: (targetItems: IWorkbookInfo[], state: AppState) => {
    if (showEncryptedButtonName(state)) {
      return Messages.extractsEncrptionActionEncrypted();
    } else if (showUnencryptedButtonName(state)) {
      return Messages.extractsEncrptionActionUnencrypted();
    } else {
      return Messages.createExtractForDsAction();
    }
  },
  isVisible: (targetItems: IWorkbookInfo[], state: AppState, availableActions: IWorkbookActions) => {
    return isVisibleOnEnabled(state);
  },
  isClickable: (availableActions: IWorkbookActions, targetItems: IWorkbookInfo[], state: AppState) => {
    return   availableActions && (availableActions.decryptExtracts || availableActions.encryptExtracts);
  },
  isChecked: (availableActions: IWorkbookActions, targetItems: IWorkbookInfo[], state: AppState) => {
    return false;
  },
  createReduxAction: (targetItems: IWorkbookInfo[]) => encryptContent(targetItems,
        SessionSiteSelectors.extractEncryptionMode(getAppStore().getState()) === ExtractEncryptionMode.ENFORCED
        ? EncryptionActionType.encryptExtracts: EncryptionActionType.decryptExtracts)
};

function isVisibleOnEnabled(state: AppState) {
  const spaceInfo: SpaceInfo = selectSpaceInfo(state);
  return CompositeSessionInfoSelectors.isWebExtractionEnabled(state) && isEncryptionEnabled(state) && isWorkbookSpace(spaceInfo);
}

function showUnencryptedButtonName(state: AppState) {
    // case  workbook has any Unencrypted extract
    const workbook: ISpaceTypeInfo  = selectSpaceInfoItem(state);
    const datasources: ReadonlyArray<IExplorableItemTypeInfo> = selectContentFromAppState(state);
    return isWorkbookUnencryptedExtract(workbook as IWorkbookInfo) ||
    isAnyDatasoursUnencrypted(_.map(datasources, ds =>ds as IDataSourceInfo));
  }

function showEncryptedButtonName(state: AppState) {
    // case  workbook has Encrypted extract
    const workbook: ISpaceTypeInfo  = selectSpaceInfoItem(state);
    const datasources: ReadonlyArray<IExplorableItemTypeInfo> = selectContentFromAppState(state);
    return isEncryptionEnforced(state) || isWorkbookEncryptedExtract(workbook as IWorkbookInfo) ||
     isAnyDatasoursEncrypted(_.map(datasources, ds =>ds as IDataSourceInfo));
  }
